module.exports = __webpack_public_path__ + "static/media/laptop2.a6b2c6f8.png";